import Button from "@/components/ui/button";
import StepLayout from "../step-layout";
import { useFeedbackFlow } from "../../hooks/use-feedback-flow";
import type { ConsentType } from "../../types";

export default function StepConsent() {
	const { data, setConsent, nextStep, canProceed } = useFeedbackFlow();

	const handleSelect = (consent: ConsentType) => {
		setConsent(consent);
	};

	const handleContinue = () => {
		if (canProceed()) {
			nextStep();
		}
	};

	return (
		<StepLayout
			header={
				<div className="mb-8">
					<h1 className="text-2xl font-semibold text-primary mb-2">How can we use your testimonial?</h1>
					<p className="text-secondary">Choose how you'd like to share your feedback</p>
				</div>
			}
			content={
				<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
					<button
						type="button"
						onClick={() => handleSelect("public")}
						className={`p-6 rounded-lg border-2 text-left transition-all ${
							data.consent === "public" ? "border-brand bg-brand/5" : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
						}`}
					>
						<div className="flex items-center gap-3 mb-2">
							<div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${data.consent === "public" ? "border-brand" : "border-gray-300"}`}>
								{data.consent === "public" && <div className="w-2.5 h-2.5 rounded-full bg-brand" />}
							</div>
							<span className="font-medium text-primary">Public Testimonial</span>
						</div>
						<p className="text-sm text-secondary pl-8">Your testimonial may be displayed on our website, marketing materials, and social media.</p>
					</button>

					<button
						type="button"
						onClick={() => handleSelect("private")}
						className={`p-6 rounded-lg border-2 text-left transition-all ${
							data.consent === "private" ? "border-brand bg-brand/5" : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
						}`}
					>
						<div className="flex items-center gap-3 mb-2">
							<div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${data.consent === "private" ? "border-brand" : "border-gray-300"}`}>
								{data.consent === "private" && <div className="w-2.5 h-2.5 rounded-full bg-brand" />}
							</div>
							<span className="font-medium text-primary">Keep Private</span>
						</div>
						<p className="text-sm text-secondary pl-8">Your feedback will only be used internally to help us improve our product.</p>
					</button>
				</div>
			}
			footer={
				<div className="flex justify-center">
					<Button onClick={handleContinue} disabled={!canProceed()} variant="brand" className="w-full">
						Continue
					</Button>
				</div>
			}
		/>
	);
}
